import { render, staticRenderFns } from "./OvertimeRunDetail.vue?vue&type=template&id=756ae0c4"
import script from "./OvertimeRunDetail.vue?vue&type=script&lang=js"
export * from "./OvertimeRunDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports